import Box from '@cloudscape-design/components/box'
import Container from '@cloudscape-design/components/container'
import Header from '@cloudscape-design/components/header'
import Link from '@cloudscape-design/components/link'
import SpaceBetween from '@cloudscape-design/components/space-between'

export default function TermsPage() {
  return (
    <Box padding="xxl">
      <Container>
        <SpaceBetween size="l">
          <Header variant="h1" description="Last updated: April 22, 2026">
            Terms of Service
          </Header>

          <SpaceBetween size="m">
            <Header variant="h2">Agreement</Header>
            <Box variant="p">
              By accessing or using Sabar, you agree to these Terms of Service. If you do not
              agree, do not use the service.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Accounts</Header>
            <Box variant="p">
              You are responsible for maintaining the confidentiality of your credentials and for
              all activity under your account. You must provide accurate information and notify us
              of any unauthorized use.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Acceptable Use</Header>
            <Box variant="p">
              You agree not to use the service to publish unlawful content, spam, impersonate
              others, attempt to disrupt the service, or violate the terms of any connected
              third-party platform (including Facebook, Google, and others).
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Third-Party Platforms</Header>
            <Box variant="p">
              Sabar integrates with external platforms. Your use of those platforms is subject to
              their terms. We are not responsible for third-party content, outages, or policy
              changes.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Termination</Header>
            <Box variant="p">
              We may suspend or terminate access for violation of these terms. You may close your
              account at any time; see our{' '}
              <Link href="/data-deletion">Data Deletion</Link> page.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Disclaimer</Header>
            <Box variant="p">
              The service is provided "as is" without warranty of any kind. To the maximum extent
              permitted by law, Sabar is not liable for indirect, incidental, or consequential
              damages.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Contact</Header>
            <Box variant="p">
              Questions about these terms can be sent to{' '}
              <Link href="mailto:legal@sabar.ai">legal@sabar.ai</Link>.
            </Box>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </Box>
  )
}
